import { create } from 'zustand';

/**
 * Transient trigger for the birthday celebration overlay. A single app-wide
 * host (<BirthdayCelebration/> in AppShell) reads this and renders the overlay
 * when `active`. Fired from the claim success and from a replay grant; the
 * points + is_last drive the copy and EVII's spoken line.
 *
 * In-memory only — the overlay is a one-shot moment, not persisted state; the
 * replay budget itself lives server-side (User.birthday_celebration_replays).
 */
interface BirthdayCelebrationState {
  active: boolean;
  points: number;
  /** True on the final allowed replay — EVII says "okay, one last time". */
  isLast: boolean;
  present: (opts: { points: number; isLast?: boolean }) => void;
  dismiss: () => void;
}

export const useBirthdayCelebration = create<BirthdayCelebrationState>((set) => ({
  active: false,
  points: 0,
  isLast: false,
  present: ({ points, isLast = false }) => set({ active: true, points, isLast }),
  dismiss: () => set({ active: false }),
}));
